import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "prevBtn", "nextBtn", "dots"]

  connect() {
    this.currentIndex = 0
    this.touchStartX = 0
    this.touchEndX = 0
    this.isTransitioning = false
    
    this.updateSlider()
    this.updateButtons()
    this.updateDots()
    
    // Auto-resize sur changement de taille de fenêtre
    this.resizeObserver = new ResizeObserver(() => {
      this.updateSlider()
    })
    this.resizeObserver.observe(this.sliderTarget)
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  get itemsPerView() {
    const width = window.innerWidth
    if (width >= 1200) return 4
    if (width >= 768) return 3
    if (width >= 480) return 2
    return 1
  }

  get maxIndex() {
    const cards = this.sliderTarget.children
    return Math.max(0, cards.length - this.itemsPerView)
  }

  prev() {
    if (this.isTransitioning || this.currentIndex === 0) return
    this.currentIndex--
    this.updateSlider()
    this.updateButtons()
    this.updateDots()
  }

  next() {
    if (this.isTransitioning || this.currentIndex >= this.maxIndex) return
    this.currentIndex++
    this.updateSlider()
    this.updateButtons()
    this.updateDots()
  }

  goToSlide(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    if (this.isTransitioning || index === this.currentIndex) return
    
    this.currentIndex = Math.min(index, this.maxIndex)
    this.updateSlider()
    this.updateButtons()
    this.updateDots()
  }

  updateSlider() {
    this.isTransitioning = true
    
    const cards = this.sliderTarget.children
    if (cards.length === 0) return

    const cardWidth = cards[0].offsetWidth
    const gap = 30 // Doit correspondre au gap CSS
    const translateX = -(this.currentIndex * (cardWidth + gap))
    
    this.sliderTarget.style.transform = `translateX(${translateX}px)`
    
    // Reset transition flag après l'animation
    setTimeout(() => {
      this.isTransitioning = false
    }, 500)
  }

  updateButtons() {
    if (!this.hasPrevBtnTarget || !this.hasNextBtnTarget) return
    
    this.prevBtnTarget.disabled = this.currentIndex === 0
    this.nextBtnTarget.disabled = this.currentIndex >= this.maxIndex
  }

  updateDots() {
    if (!this.hasDotsTarget) return
    
    const dots = this.dotsTarget.querySelectorAll('.nouveautes-dot')
    dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add('active')
      } else {
        dot.classList.remove('active')
      }
    })
  }

  // Touch/Swipe support pour mobile
  handleTouchStart(event) {
    this.touchStartX = event.touches[0].clientX
  }

  handleTouchMove(event) {
    this.touchEndX = event.touches[0].clientX
  }

  handleTouchEnd() {
    if (!this.touchStartX || !this.touchEndX) return
    
    const diff = this.touchStartX - this.touchEndX
    const threshold = 50 // Minimum swipe distance
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swipe left - next
        this.next()
      } else {
        // Swipe right - prev
        this.prev()
      }
    }
    
    this.touchStartX = 0
    this.touchEndX = 0
  }
}